// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"84f91816","769":"463d7074"}[chunkId] + ".chunk.js";
};